import axios from 'axios';
import { getTrackingPayload } from './tracking';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configured axios instance — always sends the session_token httpOnly cookie.
const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public — automatically enriches every lead submission with first-touch
// marketing & visitor attribution (utm_*, gclid/fbclid, referrer, device).
// Caller-supplied fields take precedence over auto-captured tracking.
export const submitLead = async (payload) => {
  const enriched = { ...getTrackingPayload(), ...payload };
  const { data } = await axios.post(`${API}/leads`, enriched);
  return data;
};

// ============== Admin (Google OAuth via Emergent) ==============

/**
 * Verify the current session by hitting /auth/me. Throws on 401/403.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const fetchMe = async () => {
  const { data } = await http.get('/auth/me');
  return data;
};

/**
 * Exchange a one-time Emergent OAuth session_id (from URL fragment) for
 * a persistent httpOnly cookie. Backend enforces the admin allow-list.
 */
export const exchangeGoogleSession = async (sessionId) => {
  const { data } = await http.post('/auth/google/session', { session_id: sessionId });
  return data;
};

/** Server-side logout — clears the session_token cookie. */
export const logout = async () => {
  await http.post('/auth/logout');
};

// ============== Admin (lead management) — all cookie-authed ==============

export const fetchLeads = async () => {
  const { data } = await http.get('/leads');
  return data;
};

export const updateLeadStatus = async (id, status) => {
  const { data } = await http.patch(`/leads/${id}`, { status });
  return data;
};

export const deleteLead = async (id) => {
  await http.delete(`/leads/${id}`);
};

// CSV export — opens in a new tab using the cookie session.
export const exportLeadsCsv = () => {
  window.open(`${API}/leads/export.csv`, '_blank', 'noopener');
};
